import { render, staticRenderFns } from "./terminationModal.vue?vue&type=template&id=5dc70a8e&scoped=true&"
import script from "./terminationModal.vue?vue&type=script&lang=js&"
export * from "./terminationModal.vue?vue&type=script&lang=js&"
import style0 from "./terminationModal.vue?vue&type=style&index=0&id=5dc70a8e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc70a8e",
  null
  
)

export default component.exports